<template>
  <div class="card">
    <div class="card-header" data-background-color="magenta">
      <h4>Busqueda Vehículo</h4>
      <i role="button" @click="showInstance" class="material-icons">{{ show ? 'expand_less' : 'expand_more' }}</i>
    </div>

    <!-- ## Just to wrap all for show and hide ## -->
    <div class="card-content" v-if="show">
      <div class="searchbox-container">
        <div class="searchbox">
          <fg-input-validate
            type="text"
            validations="required|numeric|max:11|min:7"
            name="número"
            label="Número"
            delay="0"
            @input-changed="input_changed"
            v-model="docSearchCriteria.identification_number"
          />

          <drop-down :title="ddTitleDoc" style="min-width: 105px; margin-left: 10px">
            <a slot="title" class="dropdown-toggle" data-toggle="dropdown">
              <span>{{ddTitleDoc}}</span>
              <i role="button" class="material-icons">expand_more</i>
            </a>
            <li>
              <a
                v-for="docType in types"
                v-bind:key="docType"
                @click="putDoc(docType)"
              >{{docType}}</a>
            </li>
          </drop-down>

          <button
            type="button"
            @click="buscarDocumento"
            :disabled="disabledSearchDoc"
            class="btn btn-primary btn-sm"
          >Buscar</button>
        </div>

        <div class="searchbox">
          <fg-input-validate
            type="text"
            validations="required|alpha_num"
            name="patente"
            label="Patente"
            delay="0"
            @input-changed="input_changed"
            v-model="domain"
          />

          <button
            type="button"
            @click="buscarPatente"
            :disabled="disabledSearchDomain"
            class="btn btn-primary btn-sm"
          >Buscar</button>
        </div>

        <div class="searchbox">
          <fg-input-validate
            type="text"
            validations="required|alpha_num"
            name="serial"
            label="Serial"
            delay="0"
            @input-changed="input_changed"
            v-model="serial"
          />

          <button
            type="button"
            @click="searchSerial"
            :disabled="disabledSearchSerial"
            class="btn btn-primary btn-sm"
          >Buscar</button>
        </div>
      </div>

      <item-list
        :table-columns-titles="tableColumnsTitles"
        :table-columns-values="tableColumnsValues"
        :table-data="searchResult"
        @rowSelectedChange="onSelectChange"
      />

      <button
        v-if="searchResult != null"
        :disabled="carSelected == null"
        class="btn btn-primary"
        @click="localizar"
      >
        Localizar
      </button>
    </div>
  </div>
</template>

<script>
import TableCar from "./TableCar.vue";
import ItemList from "../Utils/ItemList.vue";

import AccountService from "../../accountService.js";
import ThingsService from "../../thingsService.js";
import IdentificationTypes from "src/constants/identification_types.js";
export default {
  components: {
    TableCar,
    ItemList
  },
  data() {
    return {
      types: IdentificationTypes,
      disabledSearchDoc: true,
      disabledSearchDomain: true,
      disabledSearchSerial: true,
      ddTitleDoc: "DNI",
      docSearchCriteria: {
        identification_type: this.ddTitleDoc,
        identification_number: ""
      },
      show: true,
      domain: "",
      serial:"",
      searchResult: null,
      carSelected: null,
      tableColumnsTitles: [
        "Marca",
        "Modelo",
        "Dominio",
        "Motor",
        "Chasis",
        "Serial GPS"
      ],
      tableColumnsValues: [
        "make",
        "model",
        "domain",
        "engine_number",
        "chassis_number",
        "gps_serial"
      ]
    };
  },
  methods: {
    input_changed(key, has_error) {
      switch (key) {
        case "patente":
          this.disabledSearchDomain = has_error;
          break;
        case "número":
          this.disabledSearchDoc = has_error;
          break;
        case "serial":
          this.disabledSearchSerial = has_error
          break;
      }
    },

    buscarDocumento: async function() {
      this.reset_view();
      try {
        let responseAccount = await AccountService.find(this.docSearchCriteria); //Retorna una lista de elementos
        this.searchResult = [];
        if (responseAccount.body.length > 0) {
          const thingsParams = {
            type: "mrn:things:vehicle",
            _include: "child_things"
          };
          let responseThings = await ThingsService.findAccountThings(
            responseAccount.body[0].id,
            thingsParams
          );
          this.searchResult = responseThings.body.map(this.processCarResult);
        }
      } catch (error) {
        alert(JSON.stringify(error, undefined, 2));
      }
    },

    buscarPatente: function() {
      this.reset_view();
      ThingsService.findVehiculeByDomain(this.domain).then(
        responseOk => {
          this.searchResult = responseOk.body.map(this.processCarResult);
        },
        responseError => {
          console.log(
            "Error al buscar vehiculo: " +
              this.domain +
              " , " +
              JSON.stringify(responseError)
          );
        }
      );
    },

    async searchSerial() {
      this.reset_view();
      try {
        const result = await ThingsService.findVehiculeBySerial(this.serial)
        this.searchResult = result != null ? [this.processCarResult(result)] : []
      } catch (error) {
        console.log("Error al buscar vehiculo: " + this.serial + " , " + JSON.stringify(error));
      }
    },

    processCarResult(result) {
      let gpsSerial = "No posee GPS";
      if (result.includes != null && result.includes.child_things != null) {
        const gps = result.includes.child_things.filter(
          x => x.type === "mrn:things:gps"
        );
        gpsSerial = gps.length > 0 ? gps[0].info.serial_number : "Error";
      }

      return {
        id: result.id,
        make: result.info.make,
        model: result.info.model,
        domain: result.info.domain,
        engine_number: result.info.engine_number,
        chassis_number: result.info.chassis_number,
        gps_serial: gpsSerial,
        thing: result
      };
    },

    showInstance: function() {
      this.show = !this.show;
    },
    reset_view: function() {
      this.$emit("reset-view");
    },
    onSelectChange: function(result) {
      this.$emit("input-changed", result.thing);
      // console.log('car selected: ' + thing.id)
      this.carSelected = result.thing;
    },
    localizar: function() {
      this.show = false;
      this.carSelected = null;
      this.$emit("localizar");
    },
    putDoc: function(newType) {
      this.ddTitleDoc = newType;
      this.docSearchCriteria.identification_type = newType;
    }
  },

  mounted: function() {
    this.docSearchCriteria.identification_type = this.ddTitleDoc;
  },
  created: function() {
    this.docSearchCriteria.identification_number = "";
    this.domain = "";
  }
};
</script>


<style lang="scss" scoped>
button {
  margin: 0 15px 15px 0 !important;
  float: right;
}

.card-header {
  display: flex;

  & i {
    margin: auto 0 auto auto;
  }
}

.searchbox-container {
  display: flex;
  justify-content: space-around;

  .searchbox {
    display: flex;
    align-items: baseline;

    button {
      margin-left: 10px !important;
    }
  }
}

#ddDocType {
  padding-top: 15px;
}
</style>



// WEBPACK FOOTER //
// SearchCar.vue?3fefdaec